export default __webpack_public_path__ + "static/media/friend-img.745ba92e.png";